module.exports = __webpack_public_path__ + "img/portada.96b35ac8.svg";